import axios from "_u/axios"

// 管家 列表
export const shopManageList = body => {
    return axios.post("api/shop/manage/list", body)
}

// 管家 详情
export const shopManageView = id => {
    return axios.post("api/shop/manage/view", { id })
}

// 管家 新增
export const shopManageAdd = body => {
    return axios.post("api/shop/manage/add", body)
}

// 管家 修改
export const shopManageUpdate = body => {
    return axios.post("api/shop/manage/update", body)
}

// 管家 删除
export const shopManageDelete = id => {
    return axios.post("api/shop/manage/delete", { id })
}

// 管家 已选楼栋
export const queryFloorIds = id => {
    return axios.post("api/shop/manage/queryFloorIds", { id })
}


// 店面列表
export const shopInfoList = body => {
    return axios.post("api/shop/info/list", body)
}

// 店面明细
export const shopInfoView = id => {
    return axios.post("api/shop/info/view", { id })
}

// 店面新增
export const shopInfoAdd = body => {
    return axios.post("api/shop/info/add", body)
}

// 店面修改
export const shopInfoUpdate = body => {
    return axios.post("api/shop/info/update", body)
}

// 店面删除
export const shopInfoDelete = id => {
    return axios.post("api/shop/info/delete", { id })
}
